import { render } from "./JunVegas.vue?vue&type=template&id=7786fbf0"
import script from "./JunVegas.vue?vue&type=script&lang=js"
export * from "./JunVegas.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__